<div *ngIf="chips$ | async as chips; else noChips" class="chip-border hide-acc">
  <div class="container-box">
    <ul class="chip">
      <li *ngFor="let chip of chips;let i = index">
        <span *ngIf="((chip.routerLink == '') || (chips.length === (i+1)))">
          {{chip.label}}
        </span>
        <a *ngIf="((chip.routerLink !== '') && (chips.length !== (i+1)))"
          (click)="chipClick(chip)" tabindex="0">{{chip.label}}</a>
      </li>
    </ul>
  </div>
</div>

<ng-template #noChips>
  <app-breadcrumb *ngIf="!chips"></app-breadcrumb>
</ng-template>